@if (meta) {
<div class="container">
    @if (shouldDisplayPremiumOffer) {
    <offer-banner> </offer-banner>
    } @for (met of meta; track met) {
    <div class="metaContainer">
        <div
            class="titleContainer"
            [ngStyle]="getBackgroundColorForCard(met, 0)"
        >
            {{ met.title }}
        </div>
        <div class="row row-gap-4">
            @for (module of met.list_modules; track module; let i = $index) {
            <div class="col-12 col-md-6 moduleContainer">
                <div
                    class="moduleCard zoomPlusHalo"
                    [ngStyle]="getBackgroundColorForCard(met, i)"
                >
                    @if (isContentLocked(module)) {
                    <div class="overlay">
                        <i class="bi bi-lock-fill"></i>
                    </div>
                    }
                    <div class="cardContentContainer">
                        <div class="headlineContainer">
                            <div class="moduleImageWrapper">
                                <div class="whiteCircle"></div>
                                <img
                                    [src]="getModuleImg(module)"
                                    alt="Module"
                                    class="image"
                                    draggable="false"
                                />
                            </div>
                            <div class="moduleTitle">
                                {{ module.title }}
                            </div>
                        </div>
                        @if (shouldDisplayMedal(module)) {
                        <div class="bigMedalContainer">
                            <img
                                [src]="medalForModule(module)"
                                draggable="false"
                            />
                        </div>
                        }
                        <div class="badgesContainer">
                            @for (level of levels; track level) {
                            <div class="badge">
                                <img
                                    [src]="getBadge(level, module)"
                                    class="imgBadge"
                                    draggable="false"
                                />
                            </div>
                            }
                        </div>
                        <div class="progressbarContainer">
                            <div class="progressbar">
                                <div
                                    class="progress"
                                    [ngStyle]="progressStyleFor(module)"
                                ></div>
                            </div>
                            <span class="progressText"
                                >{{ progressFor(module) }} %</span
                            >
                        </div>
                        @if (shouldDisplayPlayButton(module)) {
                        <div class="playButtonContainer">
                            <div
                                class="playButton ctaBtn"
                                (click)="playModule(met, module, $event)"
                                [ngStyle]="getColorForCard(met, i)"
                            >
                                {{ "common.buttons.start" | translate }}
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    }
</div>
}
